var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHighP2Alert = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 140,
    viewBox: "0 0 358 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5911_31217",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 358,
    height: 140
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(42px)",
      clipPath: "url(#bgblur_0_5911_31217_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 84,
    d: "M0 5C0 2.23857 2.23858 0 5 0H353C355.761 0 358 2.23858 358 5V135C358 137.761 355.761 140 353 140H5.00001C2.23858 140 0 137.761 0 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5911_31217)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M415.535 10.3782C418.758 9.8574 421.919 11.6064 423.191 14.6136L472.285 130.727C473.465 133.517 472.741 136.748 470.484 138.767L372.282 226.621C370.438 228.271 367.867 228.839 365.499 228.12L269.053 198.84C266.484 198.06 264.576 195.896 264.126 193.249L249.66 108.237C249.346 106.392 249.775 104.497 250.853 102.967L301.611 30.9448C302.71 29.3861 304.39 28.3359 306.273 28.0318L415.535 10.3782Z",
    fill: "#FF9998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.54 89.6075C477.453 91.1711 478.051 93.8399 476.987 96.0703L422.613 210.029C421.657 212.031 419.568 213.238 417.357 213.066L264.568 201.203C262.132 201.014 260.133 199.203 259.703 196.799L243.473 105.909C243.221 104.498 243.544 103.046 244.37 101.875L294.752 30.434C295.636 29.181 297.014 28.3661 298.538 28.1953L385.839 18.4052C387.273 18.2444 388.712 18.6685 389.83 19.5817L390.916 18.252L389.83 19.5817L475.54 89.6075Z",
    stroke: "#FF9998",
    strokeWidth: 3.44466
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5911_31217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314 120C327.255 120 338 109.255 338 96C338 82.7452 327.255 72 314 72C300.745 72 290 82.7452 290 96C290 109.255 300.745 120 314 120Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314 92.9963V96.9963M314 100.996H314.01M312.615 87.888L304.39 102.095C303.934 102.883 303.706 103.277 303.74 103.6C303.769 103.882 303.917 104.138 304.146 104.305C304.409 104.496 304.864 104.496 305.775 104.496H322.225C323.135 104.496 323.59 104.496 323.853 104.305C324.083 104.138 324.231 103.882 324.26 103.6C324.294 103.277 324.066 102.883 323.609 102.095L315.384 87.888C314.93 87.1029 314.703 86.7103 314.406 86.5784C314.147 86.4634 313.852 86.4634 313.593 86.5784C313.297 86.7103 313.07 87.1029 312.615 87.888Z",
    stroke: "#FF544F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5911_31217_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H353C355.761 0 358 2.23858 358 5V135C358 137.761 355.761 140 353 140H5.00001C2.23858 140 0 137.761 0 135V5Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5911_31217",
    x: 278,
    y: 69.6,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.615686 0 0 0 0 0.647059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5911_31217"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5911_31217",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHighP2Alert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HighP2Alert.606da67a9a91a82c81d12eb39adf9c7c.svg";